import React, { Fragment, useState } from "react";
import apiEndPoint from "../../../utils/apiEndPoint";
import { Navigate, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import {
  loadFromLocalStorage,
  saveToLocalStorage,
} from "../../../utils/LocalStorageUtils";
import {
  apiCall,
  failedMessage,
  setDefaultHeader,
  successMessage,
} from "../../../utils/httpClient";
import { Button, Card, CloseButton, Container, Spinner } from "react-bootstrap";
import { CardBody, Modal, ModalHeader } from "reactstrap";
import { isEmpty } from "../../../utils/utils";
import LoginCover from '../logincover.png';
import "../auth.css";
import { FaApple, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import GoolgeLoginModal from "./googleLogin";
import LoginEmail from "./loginEmail";
import LoginMobile from "./loginMobile";
import { BsMailbox2 } from "react-icons/bs";
import Header from "layout/header";
import Footer from "layout/footer";
import { useEffect } from "react";
import AppleSignin from 'react-apple-signin-auth';


function Login() {
  const [email, setEmail] = useState("");
  const [emailForget, setEmailForget] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loginPage, setLoginPage] = useState('email');
  const [languageData, setLanguageData] = useState(null);
  const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
  // const [user, setUser] = useState([]);
  // const [profile, setProfile] = useState([]);
  const [isGoogleLogin, setIsGoogleLogin] = useState(false);
  const navigate = useNavigate();
  const authData = loadFromLocalStorage("AUTH_DATA");



  const [appleLogin, setAppleLogin] = useState(false);


  // useEffect(() => {
  //   const checkAppleID = () => {
  //     if (window.AppleID && window.AppleID.auth) {
  //       window.AppleID.auth.init({
  //         clientId: "com.mydigitalindia.app",
  //         scope: "name email",
  //         redirectURI: "https://mydigitalindia.app/",
  //         usePopup: true,
  //       });
  //     } else {
  //       // Retry if not loaded yet
  //       setTimeout(checkAppleID, 100);
  //     }
  //   };
  //   checkAppleID();
  // }, []);

  useEffect(() => {
    const loadAppleScript = () => {
      const script = document.createElement("script");
      script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
      script.async = true;
      script.onload = () => {
        window.AppleID.auth.init({
          clientId: "com.digitalindia.app",
          scope: "name email",
          redirectURI: "https://mydigitalindia.app",
          usePopup: true,
        });
      };
      document.body.appendChild(script);
    };

    loadAppleScript();
  }, []);

  const handleAppleSignIn = () => {
    setAppleLogin(true)
    // window.AppleID.auth.signIn();

    window.AppleID.auth
      .signIn()
      .then(async (response) => {
      console.log('response: 88888888888888888888 ', response);
        const { authorization, user } = response;
        console.log('user: 999999999999999 ', user);

        // Extract user info
        const id_token = authorization.id_token;
        const email = user?.email;
        const fullName = user?.name;
        console.log('fullName: =========> ', fullName);

        const params = {
          email: user?.email,
          apple_id: authorization.id_token,
          user_name: user?.name?.firstName + "  " + user?.name?.lastName,
          user_type: "user",
        };
        const { data } = await apiCall("post", apiEndPoint.APPLESIGNIN, params);
        if (data.status !== 200) {
          failedMessage(data.message);
        }
        if (data.status === 200) {
          successMessage(data.message);
          setDefaultHeader("token", data.data.token);
          saveToLocalStorage("AUTH_DATA", data.data);
          navigate("/");
        }
        // Send to your backend
        // fetch("https://your-backend.com/api/apple-login", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({
        //     id_token,
        //     email,
        //     fullName,
        //   }),
        // });

      }).catch((err) => {
        console.error("Apple sign-in error:", err);
      });
  };



  useEffect(() => {
    setLanguageData(selectLang?.language)
  }, [selectLang])


  if (authData?.token) {
    return <Navigate to="/" />;
  }


  const validation = () => {
    let isError = true;
    let errorMessage = {};
    if (email === undefined || email === "") {
      isError = false;
      errorMessage["email"] = "Please Enter Email ID";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      isError = false;
      errorMessage["email"] = "Invalid email address";
    }
    if (password === undefined || password === "") {
      isError = false;
      errorMessage["password"] = "Please Enter Password";
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const validationForget = () => {
    let isError = true;
    let errorMessage = {};
    if (isEmpty(emailForget)) {
      isError = false;
      errorMessage["emailForget"] = "Please Enter Email ID";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(emailForget)) {
      isError = false;
      errorMessage["emailForget"] = "Invalid email address";
    }
    setErrorMessage(errorMessage);
    return isError;
  };
  const handleLogin = async () => {
    if (validation()) {
      setLoading(true);
      const params = {
        email: email,
        password: password,
        user_type: "user",
      };
      const { data } = await apiCall("post", apiEndPoint.LOGIN, params);
      if (data.status !== 200) {
        failedMessage(data.message);
      }
      if (data.status === 200) {
        successMessage(data.message);
        setDefaultHeader("token", data.data.token);
        saveToLocalStorage("AUTH_DATA", data.data);
        navigate("/");
      }
      setLoading(false);
    }
  };
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };
  const handleForgot = async () => {
    if (validationForget()) {
      setLoading(true);
      const params = {
        email: emailForget,
      };
      const { data } = await apiCall(
        "post",
        apiEndPoint.FORGOTPASSWORD,
        params
      );
      if (data.status !== 200) {
        failedMessage(data.message);
      } else {
        saveToLocalStorage("EMAIL_ADDRESS", emailForget);
        navigate("/verification?type=forgotpassword");
      }
      setLoading(false);
    }
  };





  return (
    <Fragment>
      <Header />
      <Container>
        {isGoogleLogin &&
          <GoolgeLoginModal />
        }
        <section className="log-in-section">
          <div className="login-bg">
            {/* <div className="">
              <img
                src="/assets/images/fulllogo.png"
                alt="" width={200}
              />
            </div>
            <br /> */}
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-lg-4 my-col-2">
                {/* <div className="lt-text">
                  <h3>Create an account</h3>
                  <p>
                    Get access to our wide variety of templates and start your
                    digital journey today!
                  </p>
                </div> */}
                <div className="lt-text">
                  <h3> {languageData?.welcomelogin}</h3>
                  <p>
                    {languageData?.greatToseeu}
                  </p>
                </div>
                <div>
                  {loginPage === 'email' && <LoginEmail />}
                  {loginPage === 'mobile' && <LoginMobile />}

                  {/* <form>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>Enter your Email :</label>
                          <input
                            htmlFor="email"
                            value={email}
                            type="email"
                            size="large"
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder={"Email address"}
                            className={`${errorMessage.email ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.email && (
                            <span className="er-msg-show">
                              {errorMessage.email}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12 mt-adj">
                        <div className="input-field-box">
                          <label>Password :</label>
                          <input
                            type="password"
                            htmlFor="password"
                            // value={password}
                            size="large"
                            // onChange={(e) => setPassword(e.target.value)}
                            placeholder={"Password"}
                            className={`${errorMessage.password ? "input-errmsg" : ""
                              } form-control`}
                          />
                          {errorMessage.password && (
                            <span className="er-msg-show">
                              {errorMessage.password}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <br />
                    <div className="sav-btn mt-adj">
                      <button
                        type="button"
                        onClick={() => handleLogin()}
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <Spinner animation="border" size="sm" role="status" />
                        ) : (
                          "Continue"
                        )}
                      </button>
                    </div>
                  </div>
                </form>

                <p className="pos-adj mt-4 text-center">
                  Forget your password?
                  <a
                    onClick={() => {
                      setIsOpen(true)
                      // navigate("/signup");
                    }}
                  >
                    Click here
                  </a>
                </p> */}
                </div>
                <div style={{ position: 'relative' }}>
                  <p className="text-center" style={{ position: 'relative', top: '10px', zIndex: 1 }}>
                    <span style={{ background: '#fff', margin: '0', padding: '0 20px', }}>or</span>
                  </p>
                  <span style={{ margin: 0, borderTop: '1px solid #ddd', position: 'absolute', width: '100%', top: '20px', zIndex: 0 }} />
                </div> <br />
                {loginPage === 'email' ?
                  <Button
                    variant="outline-dark"
                    className="w-100 my-2"
                    style={{ borderRadius: "30px", fontSize: 14 }}
                    onClick={() => setLoginPage('mobile')}
                  >
                    <FaMobileAlt className="me-2" />   {languageData?.loginmobi}
                  </Button>
                  :
                  <Button
                    variant="outline-dark"
                    className="w-100 my-2"
                    style={{ borderRadius: "30px", fontSize: 14 }}
                    onClick={() => setLoginPage('email')}
                  >
                    <BsMailbox2 className="me-2" /> {languageData?.loginmail}
                  </Button>
                }
                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={() => setIsGoogleLogin(true)}
                ><FcGoogle className="me-2" /> {languageData?.logingoog}</Button>
                <Button
                  variant="outline-dark"
                  className="w-100 my-2"
                  style={{ borderRadius: "30px", fontSize: 14 }}
                  onClick={handleAppleSignIn}
                >
                  <FaApple className="me-2" /> {languageData?.loginaple}
                </Button>




                <p className="pos-adj mt-4 text-center" style={{ color: '#444', fontWeight: 400 }}>
                  {languageData?.donthavAccount}
                  <a style={{ fontWeight: 600 }}
                    onClick={() => {
                      navigate("/signup");
                    }}
                  >
                    {languageData?.signUp}
                  </a>
                </p>
              </div>
              <div className="col-lg-8 my-col-1">
                <div className="text-center">
                  <img src={LoginCover} alt="login-vector" className="login-vector" />
                </div>
              </div>
            </div>
          </div>
        </section>
        <Modal
          isOpen={isOpen}
          onRequestClose={() => setIsOpen(false)}
          style={customStyles}
          contentLabel="Example Modal"
          className="mt-4"
        >
          <Card>
            <ModalHeader toggle={() => setIsOpen(!isOpen)}>
              Forgot Password
            </ModalHeader>
            <CardBody>
              <div
                style={{ display: "flex" }}
                className="mt-2 align-items-center justify-content-md-center"
              >
                <center>
                  <small>We will send verification code on your email.</small>
                </center>
              </div>
              <form>
                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-12 mt-2">
                      <div className="input-field-box">
                        <label>Email :</label>
                        <input
                          htmlFor="email"
                          // value={emailForget}
                          type="email"
                          size="large"
                          onChange={(e) => setEmailForget(e.target.value)}
                          placeholder={"example@yahoo.com"}
                          className={`${errorMessage.emailForget ? "input-errmsg" : ""
                            } form-control`}
                        />
                        {errorMessage.emailForget && (
                          <span className="er-msg-show">
                            {errorMessage.emailForget}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <center className="mt-2">
                    <Button
                      onClick={() => handleForgot()}
                      className="back-btn"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <Spinner animation="border" size="sm" role="status" />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                  </center>
                </div>
              </form>
            </CardBody>
          </Card>
        </Modal>
      </Container>
      <Footer />
    </Fragment>
  );
}

export default Login;